import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["listView", "use"];
import { Component } from 'react';
import CalendarPopoverContextProvider from './CalendarPopoverContextProvider';
import { now, clearCachedMoments } from '../lib/time';
import CALENDAR_VIEW_TYPES from '../constants/CalendarViewTypes';
import UIDayCalendar from './UIDayCalendar';
import UIListCalendar from './UIListCalendar';
import UIMonthCalendar from './UIMonthCalendar';
// @ts-expect-error Untyped
import UIWeekCalendar from './UIWeekCalendar';
import { Metrics } from '../internal/mertrics';
import { CalendarPropsProvider } from '../internal/CalendarPropsProvider';
import { ThemeEnhancer } from '../lib/styles';
import { jsx as _jsx } from "react/jsx-runtime";
function reportApplicationId({
  applicationId,
  use,
  listView = false
}) {
  if (applicationId) {
    Metrics.counter('ui-calendar-load', {
      applicationId,
      use,
      listView: listView.toString()
    }).increment();
  }
}
function getCalendarComponent(use, listView) {
  if (listView) {
    return UIListCalendar;
  }
  switch (use) {
    case CALENDAR_VIEW_TYPES.MONTH:
      return UIMonthCalendar;
    case CALENDAR_VIEW_TYPES.DAY:
      return UIDayCalendar;
    case CALENDAR_VIEW_TYPES.WEEK:
    default:
      return UIWeekCalendar;
  }
}
class UICalendarView extends Component {
  constructor(props) {
    super(props);
    const {
      applicationId,
      use,
      currentTime,
      listView
    } = props;
    this.state = {
      currentTime: currentTime || now()
    };
    reportApplicationId({
      applicationId,
      use,
      listView
    });
  }
  componentDidUpdate(prevProps) {
    if (prevProps.applicationId !== this.props.applicationId || prevProps.use !== this.props.use || prevProps.listView !== this.props.listView) {
      reportApplicationId({
        applicationId: this.props.applicationId,
        use: this.props.use,
        listView: this.props.listView
      });
    }
  }
  componentWillUnmount() {
    clearCachedMoments();
  }
  render() {
    const _this$props = this.props,
      {
        listView,
        use
      } = _this$props,
      calProps = _objectWithoutPropertiesLoose(_this$props, _excluded);
    const CalendarComponent = getCalendarComponent(use, listView);
    return /*#__PURE__*/_jsx(CalendarPropsProvider, Object.assign({}, this.props, {
      children: /*#__PURE__*/_jsx(ThemeEnhancer, {
        children: /*#__PURE__*/_jsx(CalendarComponent, Object.assign({}, calProps, this.state, {
          listView: listView,
          use: use
        }))
      })
    }));
  }
}
UICalendarView.defaultProps = {
  use: CALENDAR_VIEW_TYPES.WEEK,
  eventDisplay: ['all-day-events', 'events'],
  hideWeekends: false,
  _incrementCurrentTime: true
};
export { UICalendarView };
export default function UICalendar(props) {
  return /*#__PURE__*/_jsx(CalendarPopoverContextProvider, {
    timezone: props.timezone,
    children: /*#__PURE__*/_jsx(UICalendarView, Object.assign({}, props))
  });
}